"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
const Speaker_1 = require("./Speaker");
const Location_1 = require("./Location");
const Track_1 = require("./Track");
const Day_1 = require("./Day");
const Schedule_1 = require("./Schedule");
const InfoPage_1 = require("./InfoPage");
const Partner_1 = require("./Partner");
const EventDescription_1 = require("./EventDescription");
const EventReg_1 = require("./EventReg");
const Form_1 = require("./Form");
const FloorPlan_1 = require("./FloorPlan");
const EsText_1 = require("./EsText");
const ScheduleItem_1 = require("./ScheduleItem");
class Event {
    constructor(description, speakers, locations, floorPlans, tracks, days, schedules, scheduleItemsMap, infoPages, partners, reg) {
        this.description = description;
        this.speakers = speakers;
        this.locations = locations;
        this.floorPlans = floorPlans;
        this.tracks = tracks;
        this.days = days;
        this.schedules = schedules;
        this.scheduleItemsMap = scheduleItemsMap;
        this.infoPages = infoPages;
        this.partners = partners;
        this.reg = reg;
    }
    static fromDto(eventDto) {
        const scheduleItemsMap = {};
        if (eventDto.schedules) {
            eventDto.schedules.forEach(schedule => {
                if (schedule.items) {
                    const items = schedule.items.map(scheduleItemDto => ScheduleItem_1.ScheduleItem.fromDto(schedule.id, scheduleItemDto));
                    scheduleItemsMap[schedule.id] = items;
                }
            });
        }
        return new Event(EventDescription_1.EventDescription.fromDto(eventDto), eventDto.speakers ? eventDto.speakers.map(speakerDto => Speaker_1.Speaker.fromDto(speakerDto)) : [], eventDto.locations ? eventDto.locations.map(locationDto => Location_1.Location.fromDto(locationDto)) : [], eventDto.floorPlans ? eventDto.floorPlans.map(floorPlanDto => FloorPlan_1.FloorPlan.fromDto(floorPlanDto)) : [], eventDto.tracks ? eventDto.tracks.map(trackDto => Track_1.Track.fromDto(trackDto)) : [], eventDto.days ? eventDto.days.map(dayDto => Day_1.Day.fromDto(dayDto)) : [], eventDto.schedules ? eventDto.schedules.map(scheduleDto => Schedule_1.Schedule.fromDto(scheduleDto)) : [], scheduleItemsMap, eventDto.infoPages ? eventDto.infoPages.map(infoPageDto => InfoPage_1.InfoPage.fromDto(infoPageDto)) : [], eventDto.partners ? eventDto.partners.map(partnerDto => Partner_1.Partner.fromDto(partnerDto)) : [], eventDto.reg ? EventReg_1.EventReg.fromDto(eventDto.reg) : new EventReg_1.EventReg(new Form_1.Form(EsText_1.EsText.createEmpty(), EsText_1.EsText.createEmpty())));
    }
    get hasScheduleItems() {
        let count = 0;
        Object.entries(this.scheduleItemsMap).forEach(([key, scheduleItems]) => {
            count += scheduleItems.length;
        });
        return count > 0;
    }
    scheduleItemById(scheduleItemId) {
        let result = undefined;
        this.schedules.forEach(schedule => {
            if (result) {
                return;
            }
            const scheduleItems = this.scheduleItemsMap[schedule.id];
            const item = scheduleItems.find(scheduleItem => scheduleItem.id === scheduleItemId);
            if (item) {
                result = item;
            }
        });
        return result;
    }
    scheduleItemsByDay(dayId) {
        const result = [];
        Object.entries(this.scheduleItemsMap).forEach(([key, scheduleItems]) => {
            scheduleItems.forEach(scheduleItem => {
                if (scheduleItem.dayId === dayId) {
                    result.push(scheduleItem);
                }
            });
        });
        return result.sort((a, b) => a.dateStart - b.dateStart);
    }
    speakerById(speakerId) {
        return this.speakers.find(speaker => speaker.id === speakerId);
    }
    static speakerTitles(allSpeakers, speakerIds) {
        let result = "";
        if (allSpeakers.length === 0) {
            return result;
        }
        speakerIds.forEach((speakerId, index) => {
            const speaker = allSpeakers.find(value => value.id === speakerId);
            if (speaker) {
                result = result + speaker.shortTitleOrTitle;
                if (index !== speakerIds.length - 1) {
                    result = result + ", ";
                }
            }
        });
        return result;
    }
    locationById(locationId) {
        return this.locations.find(location => location.id === locationId);
    }
    trackById(trackId) {
        return this.tracks.find(track => track.id === trackId);
    }
    floorPlanById(floorPlanId) {
        return this.floorPlans.find(floorPlan => floorPlan.id === floorPlanId);
    }
    dayById(dayId) {
        return this.days.find(day => day.id === dayId);
    }
    hasLocations() {
        return this.locations.filter(location => location.hasCoordinates).length > 0;
    }
    static scheduleItemTitle(scheduleItem, allSpeakers) {
        if (!scheduleItem.title) {
            if (scheduleItem.speakerIds.length > 0) {
                return Event.speakerTitles(allSpeakers, scheduleItem.speakerIds);
            }
            else {
                return "";
            }
        }
        else {
            return scheduleItem.title;
        }
    }
}
exports.Event = Event;
